<div class="container content-layout right-sidebar-fullheight-basic-inner-scroll">
  <!-- Main -->
  <div class="main">
    <!-- Header -->
    <div class="header">
      <!-- Title -->
      <div class="title">
        <h1 data-cy="objects-manager-header">Objects Manager</h1>

        <div class="objects-manager-count">
          <ng-container *ngIf="objectsManagerCount > 0">
            {{ objectsManagerCount }}
          </ng-container>
          {{
            objectsManagerCount
              | i18nPlural
                : {
                    '=0': 'No objects',
                    '=1': 'object',
                    other: 'objects',
                  }
          }}
        </div>
      </div>

      <!-- Main actions -->
      <div class="main-actions">
        <!-- Add object button -->
        <button
          class="add-object"
          mat-flat-button
          data-cy="new-custom-object"
          color="primary"
          (click)="addCustomObject()"
        >
          <mat-icon [svgIcon]="'add'"></mat-icon>
          New Object
        </button>
      </div>
    </div>

    <mat-progress-bar mode="indeterminate" [class.hidden]="!isLoading"></mat-progress-bar>

    <!-- Objects Manager list -->
    <div class="objects-manager-list">
      <div class="table-wrapper">
        <div class="inline-table-wrapper">
          <ng-container *ngIf="objectsManagerCount > 0; else noObjects">
            <!-- Table -->
            <table mat-table [dataSource]="objectItems" [trackBy]="trackByFn">
              <!-- Name -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td
                  mat-cell
                  *matCellDef="let objectItem"
                  [routerLink]="['./', objectItem.id || objectItem.name]"
                  data-cy="custom-object-list-item"
                >
                  <div class="name-content">
                    <span class="name">{{ objectItem?.label }}</span>
                    <span>
                      @if (!objectItem?.search_custom_field_id && objectItem.id) {
                        <mat-icon
                          class="ml-12 warning-icon"
                          [svgIcon]="'warning'"
                          matTooltip="Search field configuration is pending"
                        ></mat-icon>
                      }
                    </span>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="objectsManagerTableColumns; sticky: true"></tr>
              <tr
                class="objects-manager-row"
                mat-row
                *matRowDef="let objectItem; columns: objectsManagerTableColumns"
              ></tr>
            </table>
          </ng-container>
        </div>

        <ng-template #noObjects>
          <div class="no-objects">There are no objects!</div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
